/**
 * Stable portal targets for Packers Android Menu slot (London Smoke & Cure).
 */

import { useCallback, useSyncExternalStore } from 'react';
import {
    getPackersToolbarSlotSnapshot,
    subscribePackersToolbarSlots,
} from './packersToolbarSlotRegistry';

export const PACKERS_TOOLBAR_SLOT_CLASS = {
    sections: 'packers-mobile-toolbar__slot--sections',
    scales: 'packers-mobile-toolbar__slot--scales',
    quickBar: 'packers-mobile-toolbar__slot--quick-bar',
    qr: 'packers-mobile-toolbar__slot--qr',
    menu: 'packers-mobile-toolbar__slot--menu',
};

/**
 * @param {'sections'|'scales'|'quickBar'|'qr'|'menu'|null} slotName
 * @returns {HTMLElement|null}
 */
export function usePackersToolbarSlot(slotName) {
    const subscribe = useCallback(
        (onStoreChange) => subscribePackersToolbarSlots(onStoreChange),
        []
    );

    const getSnapshot = useCallback(() => {
        if (!slotName) return null;
        return getPackersToolbarSlotSnapshot(slotName);
    }, [slotName]);

    const getServerSnapshot = useCallback(() => null, []);

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}

export function isPackersUnifiedToolbarActive() {
    return (
        typeof document !== 'undefined' &&
        document.body.classList.contains('packers-mobile-chrome') &&
        document.body.getAttribute('data-packers-unified-toolbar') === 'true'
    );
}
